import { LoginSection } from 'LoginUI';
import {
  SelectWalletBox,
} from './KeysAndSigningUI';
import { ForDevelopment } from './dev/developmentUI';
import { TextLine3 } from './UtilComponents';
import {
  useGlobalStateSelector,
  words,
} from './globalState';
import {
  handleClickActivateMonatokaPoint,
  handleClickGetActivationHistory,
} from './retailer';
import {
  handleClickGoTop,
  handleClickScanQr,
  localTime,
} from './utils';
import iconQr from './qr_code_2_FILL0_wght400_GRAD0_opsz24.svg';
import iconCircleLeft from './arrow_circle_left_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleRight from './arrow_circle_right_FILL0_wght400_GRAD0_opsz48.svg';
import iconSearch from './search_FILL0_wght400_GRAD0_opsz48.svg';

// RETAILER
function Retailer() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);

  // useEffect( () => {
  //   dispatch({ type: 'setState', key: 'session', value: {} });
  // }, []);

  // const preFunction = () => {
  //   dispatch({ type: 'setState', key: 'session', value: {} });
  // };

  let activation = <Activation />;
  let activationList = <ActivationList />;

  // if (state.activationList.activatee.length >= 1) {
  //   activation = <Activation />;
  // }

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentFlexEnd marginBottom1' >
      <button className='button2' onClick={ () => handleClickGoTop(state, dispatch, navigate) }>
        { words.back[state.language] }
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div className='flexColumn alignItemsCenter widthMax ' >
      { headerRelative }
      <div className='margin1 borderKOM ' >
        <SelectWalletBox keypoolButtonVisible={false} />
        <div className='padding0p5 ' >
          <LoginSection />
          {/* <LoginSection preFunction={preFunction} postFunction={getActivationList} /> */}
        </div>
      </div>
      <div className='padding0p5 margin1 borderKOM ' >
        { activation }
      </div>
      <div className='' >
        { activationList }
      </div>
      { headerFixed }
    </div>
  );
}

// ACTIVATION
function Activation() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);

  return (
    <div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginBottom1 '
        onClick={ () => {
          const callback = (addressMainEncrypted) => {
            dispatch({ type: 'setStateMultiLayers', keys: ['activation', 'addressMainEncrypted'], value: addressMainEncrypted });
          };

          handleClickScanQr(state, dispatch, callback, { callbackType: 'simpelCallback' });
        }}
      >
        <div>
          { words.scan[state.language] }
        </div>
        <img className='size2x2' src={iconQr} alt='qr' />
      </button>
      <TextLine3 fieldName='activationAddressMainEncrypted' keys={['activation', 'addressMainEncrypted']} face={words.activationCode[state.language]} tooltip='true' />
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTop1 '
        onClick={ () => {
          handleClickActivateMonatokaPoint(state, dispatch);
        }}
      >
        <div>
          { words.activate[state.language] }
        </div>
      </button>
    </div>
  );
}

// ACTIVATION LIST
function ActivationList() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  let historyItems;
  let historyFunction;
  let arrowLeft;
  let arrowRight;

  // アクションごとのhistoryItemsとhistoryFunction設定。

  if (state.activationList.action === 'activationHistoryAll') {
    if (state.activationList.activationHistoryAll?.keyCard !== undefined) {
      historyItems = state.activationList.activationHistoryAll.keyCard.map( record => {
        if (true) {
          return <ActivationRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<ActivationRecordTitle />);
    }
    else {
      historyItems = [<ActivationRecordTitle />];
    }

    historyFunction = (pagingIndex) => handleClickGetActivationHistory(state, dispatch, pagingIndex);
  }

  if (state.activationList.action === 'activationHistoryAddressMainEncrypted') {
    if (state.activationList.activationHistoryAddressMainEncrypted?.keyCard !== undefined) {
      historyItems = state.activationList.activationHistoryAddressMainEncrypted.keyCard.map( record => {
        if (true) {
          return <ActivationRecord record={record} />
        }
        else {
          return null;
        }
      });

      historyItems.unshift(<ActivationRecordTitle />);
    }
    else {
      historyItems = [<ActivationRecordTitle />];
    }

    historyFunction = (pagingIndex) => handleClickGetActivationHistory(state, dispatch, pagingIndex);
  }

  // 矢印

  if ( state.activationList.pagingIndex[state.activationList.action] >= 1 ) {
    arrowLeft = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => historyFunction(state.activationList.pagingIndex[state.activationList.action] - 1) }
      >
        <img className='size2x2' src={iconCircleLeft} alt='left' />
      </button>
    </div>
  }
  else {
    arrowLeft = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  if ( (state.activationList.lastEvaluatedKey[state.activationList.action][state.activationList.pagingIndex[state.activationList.action]] !== undefined &&
        state.activationList.lastEvaluatedKey[state.activationList.action][state.activationList.pagingIndex[state.activationList.action]] !== null        )
       // || (state.activationList.lastEvaluatedKey2[state.activationList.action]?.[state.activationList.pagingIndex[state.activationList.action]] !== undefined &&
       //  state.activationList.lastEvaluatedKey2[state.activationList.action]?.[state.activationList.pagingIndex[state.activationList.action]] !== null        )
  ) {
    arrowRight = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => { historyFunction(state.activationList.pagingIndex[state.activationList.action] + 1) } }
      >
        <img className='size2x2' src={iconCircleRight} alt='right' />
      </button>
    </div>
  }
  else {
    arrowRight = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  // ページングパラメータリセット関数

  // eslint-disable-next-line no-unused-vars
  const resetPagingParameters = () => {
    dispatch({ type: 'setStateMultiLayers', keys: ['activationList', 'pagingIndex'],
      value: { activationHistoryAll: 0, activationHistoryAddressMainEncrypted: 0 }
    });

    dispatch({ type: 'setStateMultiLayers', keys: ['activationList', 'lastEvaluatedKey'],
      value: { activationHistoryAll: [], activationHistoryAddressMainEncrypted: [] }
    });

    // dispatch({ type: 'setStateMultiLayers', keys: ['activationList', 'lastEvaluatedKey2'],
    //   value: { activationHistoryAll: [], activationHistoryAddressMainEncrypted: [] }
    // });
  };


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexColumn'>
          {/* history */}
          <div className='flexRow justifyContentFlexStart alignItemsCenter '>
            {/* action */}
            <div className='flexRow justifyContentSpaceAround marginSide0p5 '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.activationList.action === 'activationHistoryAll' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['activationList', 'action'], value: 'activationHistoryAll'});
                }}>
                {words.all[state.language]}
              </button>
            </div>
            <div className='flexRow justifyContentSpaceAround marginSide0p5 '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.activationList.action === 'activationHistoryAddressMainEncrypted' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['activationList', 'action'], value: 'activationHistoryAddressMainEncrypted'});
                }}>
                {words.single[state.language]}
              </button>
            </div>
            <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
              <img className='size2x2' src={iconSearch} alt='search' />
            </button>
            { arrowLeft }
            { arrowRight }
          </div>
          { historyItems }
          {/* development */}
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess">
        <div className='flexColumn'>
          {/* control */}
          {/* action */}
          <div className='flexRow justifyContentFlexStart alignItemsCenter '>
            <div className='flexRow justifyContentFlexStart '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.activationList.action === 'activationHistoryAll' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['activationList', 'action'], value: 'activationHistoryAll'});
                }}>
                {words.all[state.language]}
              </button>
            </div>
            <div className='flexRow justifyContentFlexStart '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.activationList.action === 'activationHistoryAddressMainEncrypted' ? 'colorRed borderSelected' : 'borderNone')} tabindex='0'
                onClick={ () => {
                          dispatch({type: 'setStateMultiLayers', keys: ['activationList', 'action'], value: 'activationHistoryAddressMainEncrypted'});
                }}>
                {words.single[state.language]}
              </button>
            </div>
            <div className='flexColumn justifyContentCenter alignItemsFlexStart '>
              <div className='flexRow justifyContentFlexStart alignItemsCenter '>
                <button className='button1' tabindex='0' onClick={ () => historyFunction(0) } >
                  <img className='size2x2' src={iconSearch} alt='search' />
                </button>
              </div>
            </div>
          </div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter margin1 '>
            { arrowLeft }
            { arrowRight }
          </div>
          { historyItems }
        </div>
      </div>
    </div>
  );
}

// ACTIVATION RECORD TITLE
function ActivationRecordTitle() {
  const state = useGlobalStateSelector(({ state }) => state);

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin40' >
            { words.activationCode[state.language] }
          </div>
          <div className='marginSide1 widthMin12' >
            { words.status[state.language] }
          </div>
          <div className='marginSide1 widthMin12' >
            { words.activationTime[state.language] }
          </div>
          <div className='marginSide1 widthMin12' >
            { words.registrationTime[state.language] }
          </div>
          {/*
            <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
          */}
        </div>
      </div>
      {/* SP */}
    </div>
  );
}

// ACTIVATION RECORD
function ActivationRecord(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const record = props.record;
  // let buttons;
  // let popup;

  // popup = { type: 'duelHistoryDetail', body: record };
  // buttons =
  // <button className='button1'
  //   onClick={ () => {
  //     dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'round'], value: 0 });
  //     // dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
  //     dispatch({ type: 'setStateMultiLayers', keys: ['popup', 100], value: popup });
  //     navigate(
  //       process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/duelhistorydetail' : '/duelhistorydetail',
  //       { state: { previousLocation: 'duelhistory' } }
  //     )
  //   }}
  // >
  //   <img className='size2x2' src={iconDetail} />
  // </button>;


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin40' >
            { record.addressMainEncrypted }
          </div>
          <div className='marginSide1 widthMin12' >
            { words[record.status][state.language] }
          </div>
          <div className='marginSide1 widthMin12' >
            { localTime(record.activateTime, 'yearToSecond') }
          </div>
          <div className='marginSide1 widthMin12' >
            { localTime(record.registrationTime, 'yearToSecond') }
          </div>
          {/* buttons */}
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          {/*
            <div className='flexRow justifyContentFlexEnd alignItemsCenter width98PC'>
              { buttons }
            </div>
          */}
          <div className='flexColumn alignItemsFlexStart width98PC'>
            <div className='' >
              { words.activationCode[state.language] }
            </div>
            <div className='paddingLeft1 breakAll ' >
              { record.addressMainEncrypted }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.status[state.language] }
            </div>
            <div className='' >
              { words[record.status][state.language] }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.activationTime[state.language] }
            </div>
            <div className='' >
              { localTime(record.activateTime, 'yearToSecond') }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.registrationTime[state.language] }
            </div>
            <div className='' >
              { localTime(record.registrationTime, 'yearToSecond') }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export {
  Retailer,
}